export default __webpack_public_path__ + "static/media/BrushIcon.0c4bcf61.webp";